<div class="page-wrapper">
    <!-- <app-header></app-header> -->
    <div class="content-wrapper">
        <div class="page-content">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>